import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0109700e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-title-button" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "add_circle", -1))
const _hoisted_3 = {
  key: 1,
  class: "table table-hover table-v2"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  colspan: "2",
  class: "fw-bold small text-uppercase text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_offcanvas_button_open = _resolveComponent("base-offcanvas-button-open")!
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_CustomerCategoryNode = _resolveComponent("CustomerCategoryNode")!
  const _component_base_container = _resolveComponent("base-container")!
  const _component_CustomerCategory = _resolveComponent("CustomerCategory")!
  const _component_base_offcanvas = _resolveComponent("base-offcanvas")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_BaseTitle, {
          title: _ctx.$t('ownSubCategories'),
          mb: 4
        }, {
          buttons: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_base_offcanvas_button_open, {
                "offcanvas-id": "offcanvas-customer-category",
                class: "btn btn-hover icon-link",
                onBeforeOpen: _ctx.prepareOffCanvasForNewCategory
              }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('add')), 1)
                ]),
                _: 1
              }, 8, ["onBeforeOpen"])
            ])
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_AlertError2, {
          error: _ctx.pageUI.getError()
        }, null, 8, ["error"]),
        (!_ctx.pageUI.getIsReady())
          ? (_openBlock(), _createBlock(_component_base_spinner, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.pageUI.isReady())
          ? (_openBlock(), _createElementBlock("table", _hoisted_3, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('name')), 1),
                  _hoisted_4
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_ctx.categoryTree.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                      _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.$t('noResults')), 1)
                    ]))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.categoryTree, (rootNode) => {
                      return (_openBlock(), _createBlock(_component_CustomerCategoryNode, {
                        key: rootNode.code,
                        "tree-node": rootNode,
                        level: 0,
                        open: _ctx.open,
                        onToggleOpen: _ctx.toggleOpen,
                        onEditCategory: _ctx.prepareOffCanvasForEditCategory,
                        onDeleteCategory: _ctx.deleteCategory
                      }, null, 8, ["tree-node", "open", "onToggleOpen", "onEditCategory", "onDeleteCategory"]))
                    }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_base_offcanvas, {
      title: _ctx.$t('customerCategory'),
      id: "offcanvas-customer-category",
      class: "offcanvas-wider"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_component_CustomerCategory, {
          key: _ctx.categorySequence,
          code: _ctx.categoryCode,
          mode: _ctx.categoryMode,
          "all-languages": _ctx.allLanguages,
          "all-customer-categories": _ctx.categories?.results ?? [],
          onEdit: _ctx.reloadContent
        }, null, 8, ["code", "mode", "all-languages", "all-customer-categories", "onEdit"]))
      ]),
      _: 1
    }, 8, ["title"])
  ], 64))
}